module.exports = __webpack_public_path__ + "static/img/yun01_8.b88c6ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_8.jpg
// module id = +p9X
// module chunks = 1